module.exports = __webpack_public_path__ + "img/hdyy_1.91ac07ad.png";